import { bool, crudTable, index, text } from "@-/dev.improve.haniverse.lib.database.table";

/**
 * Per-actor vocabulary progress. Static catalog IDs change between builds, so key by text.
 *
 * One row per word: the row id is derived from it (`deriveUserWordId`), so no unique index is
 * needed, and none may be added (sync cannot resolve a unique conflict).
 */
export const userWordTable = crudTable(
  "user_word",
  {
    locked: bool("locked").notNull().default(true),
    word: text("word").notNull(),
  },
  (table) => [index("user_word_word_idx").on(table.word)],
);

export type UserWord = typeof userWordTable.$inferSelect;
